module.exports = __webpack_public_path__ + "img/zonefMap.webp";